<template>
	<div class="section-footer" id="footer">
		<v-layout wrap justify-end>
			<v-flex xs12 class="section-car">
				<v-layout wrap class="wrapper-top">
					<v-flex class="text-footer">
						<img :src="`${$S3}logo-mibodega-green.png`" alt="logo mi bodega" height="35">
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md5 class="margin-negative">
				<form-component @open-modal="$emit('open-modal')"/>
			</v-flex>
			<v-flex xs12 md7 class="padding-responsive">
				<v-layout row wrap>
					<v-flex xs12 sm6 md12>
						<div class="footer-info">
							<p class="name-country mb-1">Perú</p>
							<div class="mb-3">
								<a
									href="https://goo.gl/maps/8vAGxHq1v49WAxj26" 
									class="mb-0 bold direction"
									target="_blank"
								>
									Lima
								</a>
								<p class="mb-0">+51 940 637 220</p>
								<p class="mb-0">Calle Independencia  106,  Piso 10</p>
								<p class="mb-0">Miraflores</p>
							</div>
						</div>
						<div class="footer-info">
							<p class="name-country mb-1">Ecuador</p>
							<div class="mb-3">
								<a
									href="https://www.google.com/maps/search/Pinta+236+y+R%C3%A1bida.+Edif.+La+Pinta/@-0.1992127,-78.4896696,18z" 
									class="mb-0 bold direction"
									target="_blank"
								>
									Quito
								</a>
								<p class="mb-0">PBX(02) 6040226 - +593 998514801</p>
								<p class="mb-0">Pinta 236 y Rábida. Edif. La Pinta Of. 502</p>
							</div>
						</div>
					</v-flex>
					<v-flex xs12 sm6 md12>
						<div class="left screen-phone">
							<img :src="`${$S3}phone-app-screen-footer-min.png`" alt="app mi bodega" />
						</div>
						<div class="wrapper-links-desktop right p-141 mb-5 mt-3">
							<a 
								href="https://www.facebook.com/Mi-bodega--107633674246248/?modal=admin_todo_tour"
								class="mr-3"
								target="_blank"
							>
								<img :src="`${$S3}facebook-logo.png`" alt="facebook" height="30px">
							</a>
							<a 
								href="https://www.instagram.com/mibodegape/"
								target="_blank"
							>
								<img :src="`${$S3}instagram-logo.png`" alt="instagram" height="30px">
							</a>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<div class="footer-end">
			<p class="mb-0">Derechos reservados <a href="https://www.makipos.la" target="_blank" class="link">makipos.la</a> | Desarrollado por apprunn</p>
		</div>
	</div>
</template>
<script>
import formComponent from '@/components/home/form-component';

export default {
	name: 'section-footer',
	components: {
		formComponent,
	},
	props: {
		provinces: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>
	.section-footer {
		position: relative;

		@media (min-width: 936px) {
			min-height: 733px;
		}
	}

	.section-car {
		border-bottom: 6px solid color(green-link);
		padding: 85px 7% 28.6px;

		@media (max-width: 936px) {
			padding: 77px 5% 25px;
		}
	}

	.text-footer {
		font-family: font(lato-regular);
		font-weight: 600;
		font-size: 17px;
		text-align: right;
		width: 75%;

		@media (max-width: 936px) {
			color: color(title-green);
			font-size: 24px;
			text-align: center;
			width: 100%;
		}
	}

	.footer-info {
		color: color(title-green);
		padding: 30px 20% 0px;
		text-align: right;

		@media (max-width: 1200px) {
			padding: 30px 12% 0 0;
		}

		@media (max-width: 936px) {
			padding: 0px 12% 30px;
			text-align: left;
		}
	}

	.right {
		text-align: right;
	}

	.p-141 {
		padding: 0px 20% 0 0;

		@media (max-width: 1200px) {
			padding: 0px 12% 0 0;
		}

		@media (max-width: 936px) {
			padding: 0px 6% 0 0;
		}
	}

	.name-country {
		font-family: font(lato-regular);
		font-weight: 600;
		font-size: 24px;
	}

	.wrapper-footer {
		margin-bottom: 40px;
		position: absolute;
		top: 68px;
		left: 141px;

		@media (max-width: 936px) {
			display: none;
		}
	}

	.bold {
		font-family: font(lato-regular);
		font-weight: 600;
	}

	.wrapper-image-desktop {
		@media (max-width: 936px) {
			display: none;
		}
	}

	.wrapper-top {
		margin-left: auto;
		width: calc(100% - 442px);

		@media (max-width: 936px) {
			width: 100%;
		}
	}

	.wrapper-links-desktop {
		@media (max-width: 936px) {
			display: none;
		}
	}

	.wrapper-links-mobile {
		border-bottom: 6px solid color(green-link);
		display: none;
		margin: 99px 0 50px 0;
		padding: 0px 7%;

		@media (max-width: 936px) {
			display: flex;
			margin: 0;
		}
	}

	.direction {
		color: color(title-green);
		text-decoration: none;
	}

	.footer-end {
		background: color(green-link);
		bottom: 0;
		color: color(white);
		font-family: font(lato-regular);
		font-size: size(medium16);
		font-weight: map-get($weight, w900);
		padding: 14px 0;
		position: absolute;
		text-align: center;
		width: 100%;
	}

	.mb-260 {
		margin-bottom: 260px;

		@media (max-width: 936px) {
			margin-bottom: 50px;
		}
	}

	.margin-negative {
		margin-top: -58px;

		@media (max-width: 1200px) {
			padding-left: 5%;
		}

		@media (max-width: 936px) {
			padding-left: 0;
			margin-top: 0px;
		}
	}

	.padding-responsive {
		padding-left: 32px;

		@media (max-width: 1200px) {
			padding-left: 20px;
		}

		@media (max-width: 936px) {
			padding-left: 0px;
		}
	}

	.screen-phone {
		margin-top: 60px;
		padding-left: 28px;

		@media (max-width: 936px) {
			margin: 0px auto;
			padding-bottom: 52px;
			padding-left: 0px;
			text-align: center;
			width: 100%;
		}

		img {
			height: 361px;

			@media (max-width: 936px) {
				height: 277px;
			}
		}
	}

	.link {
		color: map-get($colors, white);
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-footer.vue